import TranslationMap from "../../models/translationMap";
import {
    SET_SESSION_DATA,
    SET_IS_LOADING,
    SET_VIRTUAL_KEYBOARD,
    RESET_FOR_MODEL_SELECTOR,
} from "../actions/sessionActions";
import SessionState from "../stateTypes/sessionState";

const initialState: SessionState = {
    sessionData: null,
    frontendSettings: null,
    appConfig: null,
    summaryData: null,
    applicationSettings: {},
    isLoading: true,
    language: null,
    showPrice: false,
    account: null,
    showFilters: false,
    guiTranslation: new TranslationMap(),
    appVersion: "Unknown",
    touchScreen: false,
    appCustomization: null,
    showVirtualKeyboard: false,
};

const sessionReducer = (state: SessionState = initialState, action: any = {}) => {
    switch (action.type) {
        case SET_SESSION_DATA:
            return {
                ...state,
                sessionData: action.sessionData,
                frontendSettings: action.frontendSettings,
                appConfig: action.appConfig,
                summaryData: action.summaryData,
                applicationSettings: action.applicationSettings,
                language: action.language,
                showPrice: action.showPrice,
                account: action.account,
                showFilters: action.showFilters,
                guiTranslation: action.guiTranslation,
                appVersion: action.appVersion,
                touchScreen: action.touchScreen,
                appCustomization: action.appCustomization,
            };
        case SET_IS_LOADING:
            return {
                ...state,
                isLoading: action.isLoading,
            };
        case SET_VIRTUAL_KEYBOARD:
            return {
                ...state,
                showVirtualKeyboard: action.showVirtualKeyboard,
            };
        // Intentionally do not clear session when navigating to model selector; keep sessionId for reuse when loading another config.
        case RESET_FOR_MODEL_SELECTOR:
            return state;
        default:
            return state;
    }
};

export default sessionReducer;
